import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { LANGUAGESDATA } from '@shared/models/constants/languagesData';
import { LanguageData } from '@shared/models/interfaces/language.interface';

@Component({
  selector: 'app-language-popover',
  templateUrl: './popover-languages.component.html',
  styleUrls: ['./popover-languages.component.scss']
})
export class PopoverLanguagesComponent {
  public languages: LanguageData[]= LANGUAGESDATA;

  constructor(private popoverController: PopoverController){}

  async dismiss(index: number) {
      await this.popoverController.dismiss({languageSelected: this.languages[index]});
  }
}